import { formatDate } from '../../utils';

const transformSolutionsWithCount = ({ results = [], count }) => ({
  results: results.map(({ id, status, displayName, createdAt, description }) => ({
    id,
    status,
    name: displayName,
    description,
    createdOn: formatDate(createdAt),
  })),
  count,
});

export default transformSolutionsWithCount;
